export default {"src":"/_next/static/media/sweetener.f9c72c7e.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};